import { BuyerCreationStepContent } from "./BuyerCreationStepContent";

export const BuyerCreationStep = ({
  lockEmail = false,
}: {
  lockEmail?: boolean;
}) => {
  return <BuyerCreationStepContent lockEmail={lockEmail} />;
};
